import React, { Component } from 'react';

import BackdropProgress from './core/components/BackdropProgress';
import Button from '@material-ui/core/Button';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import ConfirmDialog from './core/components/ConfirmDialog';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import GitHubIcon from '@material-ui/icons/GitHub';
import Grid from '@material-ui/core/Grid';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Skeleton from '@material-ui/lab/Skeleton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import Tooltip from '@material-ui/core/Tooltip';
import { authenticationService } from '_services';
import { green } from '@material-ui/core/colors';
import { history } from '_helpers';
import { orange } from '@material-ui/core/colors';
import { releaseService } from '_services';
import update from 'immutability-helper';
import { withStyles } from '@material-ui/core/styles';

const useStyles = (theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
});

const tableStyle = {
  border: "none",
  width: 160
};

class QaPromotion extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      currentUserId: '',
      confirmationDialog: false,
      promotionResponse: [],
      promotionState: [],
      // regressionVersion: '',
      releaseResponse: [],
      updateReleaseArtifactsRequest: [],
      updateReleaseArtifactsResponse: [],
    };
    this.addArtifactsForPromotion = this.addArtifactsForPromotion.bind(this);
    this.updateReleaseArtifacts = this.updateReleaseArtifacts.bind(this);
    this.transformPromotionResponse = this.transformPromotionResponse.bind(this);
    this.handleReleaseVersionChange = this.handleReleaseVersionChange.bind(this);
  }

  getReleases(){
    releaseService.getAllReleases().then(
      (data) => {
        this.setState({
          loading: false,
          regressionVersion: data[0],
          releaseResponse: data,
        })
      }
    )
  }
  
  getReleaseMetadata(releaseVersion) {
    
    releaseService.getReleaseMetadata(releaseVersion).then(
      (data) => {
        this.setState(preState => ({
          ...preState,
          loading: false,
          promotionResponse: data,
          promotionState: [],
          updateReleaseArtifactsRequest: []
        }));
        this.transformPromotionResponse(data)
      },
      (error) => {
        // TO-DO Add Error component
      },
    );
  }

  addArtifactsForPromotion = (artifact, e) => {
    let id = parseInt(e.target.value) || '';
    let promotionState = this.state.promotionState;
    let artifactIndex = promotionState.findIndex(ps => ps.artifact === artifact);

    var updatedPromoted = update(promotionState[artifactIndex], { toBePromoted: { $set: id } });

    var newPromotionState = update(promotionState, {
      $splice: [[artifactIndex, 1, updatedPromoted]]
    });
    this.setState({
      promotionState: newPromotionState
    });
  };

  addArtifactsToPromotion(id) {
    const releaseObject = { id: id, qaApprovedBy: this.state.currentUserId };
    return releaseObject
  }

  updateReleaseArtifacts = () => {
    this.setState({ loading: true });
    releaseService.updateReleaseArtifacts(this.state.updateReleaseArtifactsRequest, this.state.regressionVersion )
      .then((response) => {
        this.setState({
          updateReleaseArtifactsResponse: response,
          loading: false,
        });
      })
      .then(
        setTimeout(function () {
          history.push('/admin/prodManifest');
        }, 2000),
      );
  };

  fetchToBePromotedArtifacts() {
    let promotionState = this.state.promotionState;
    let promotedList = promotionState.reduce((pl, ps) => {
      if ((ps.id === "" && ps.toBePromoted !== "") || (ps.toBePromoted !== "" && ps.id !== ps.toBePromoted)) {
        pl.push(this.addArtifactsToPromotion(ps.toBePromoted))
      }
      return pl
    }, [])
    this.setState({
      updateReleaseArtifactsRequest: promotedList,
    });
  }

  renderVersionsDropdown(versions, artifactId) {
    const selectList = [];
    let approvedId = '';
    selectList.push(<option key="000" aria-label="None" value="" />);
    versions.map(version => {
      // console.log("🚀 ~ file: QaPromotion.js ~ line 145 ~ QaPromotion ~ renderVersionsDropdown ~ version.qaLatestApproval", version.qaLatestApproval, artifactId)
      if (version.qaLatestApproval) {
        approvedId = version.id
      }
      return selectList.push(
        <option key={version.id} value={version.id} >
          {version.version}
        </option>,
      );

    });
    // console.log("🚀 ~ file: QaPromotion.js ~ line 168 ~ QaPromotion ~ renderVersionsDropdown ~ selectList", selectList)

    return (
      <Select native defaultValue={approvedId} onChange={(e) => this.addArtifactsForPromotion(artifactId, e)}>
        {selectList}
      </Select>
    );
  }

  renderConfirmationDialog() {
    let promotionState = this.state.promotionState;
    const conformationList = []
    promotionState.map(ps => {
      if (ps.toBePromoted && ps.toBePromoted !== ps.id) {
        var artifactList = this.state.promotionResponse.find((artifacts) => artifacts.artifact === ps.artifact);
        var versionList = artifactList.versions.find((versions) => versions.id === ps.toBePromoted);
        return conformationList.push(
          <TableRow key={ps.artifact}>
            <TableCell component="th" scope="row" style={{ width: 200, border: 'none' }}>
              {ps.artifact}
            </TableCell>
            <TableCell align="right" style={tableStyle}>
              {ps.version}
            </TableCell>
            <TableCell align="right" style={tableStyle} >
              {versionList.version}
            </TableCell>
            <TableCell style={{ width: 60, border: 'none' }}>
              <a rel="noopener noreferrer" target="_blank" href={versionList.scmUrl}>
                <GitHubIcon color="primary" />
              </a>
            </TableCell>
          </TableRow>
        )
      }
      return conformationList;
    });
    return conformationList
  }

  isQaApproved(versions) {
    var qaApproved = versions.find((versions) => versions.qaLatestApproval);
    if (qaApproved !== undefined) {
      return (
        <Tooltip title={"Approved By -  " + qaApproved.qaApprovedBy} placement="right">
          <CheckCircleOutlinedIcon style={{ color: green[500] }} />
        </Tooltip>
      );
    } else {
      return <HourglassEmptyIcon style={{ color: orange[500] }} />;
    }
  }

  transformPromotionResponse(pr) {
    let promotionObject = pr.map(prm => {
      let versionMap = prm.versions.reduce((releaseArtifactObject, version) => {
        if (version.qaLatestApproval) {
          releaseArtifactObject = { id: version.id, version: version.version, isApproved: version.qaLatestApproval };
        }
        return releaseArtifactObject;
      }, [])
      let releaseArtifactObject = { team: prm.team, artifact: prm.artifact, id: versionMap.id ?? '', version: versionMap.version ?? '', isApproved: versionMap.isApproved ?? '', toBePromoted: '' };
      return releaseArtifactObject
    }, []);

    this.setState(preState => ({
      ...preState,
      promotionState: promotionObject
    }));
  }

  // findIndexByKeyValue(_array, key, value) {
  //   for (var i = 0; i < _array.length; i++) {
  //     if (_array[i][key] === value) {
  //       return i;
  //     }
  //   }
  //   return -1;
  // }

  // handleVersionChange(e) {
  //   e.persist();
  //   this.addArtifactsForPromotion(e.target.value, this.state.currentUserId);
  // }

  handleClickOpen = () => {
    this.fetchToBePromotedArtifacts()
    this.setState({ confirmationDialog: true });
  };

  setOpen = (state) => {
    this.setState({ confirmationDialog: state });
  };

  handleReleaseVersionChange = (e) => {
    let releaseVersion = e.target.value

    this.setState({
      regressionVersion: releaseVersion
    })
    this.getReleaseMetadata(releaseVersion)
  }


  componentDidMount() {
    authenticationService.currentUserId.subscribe(x => this.setState({
      currentUserId: x
    }));
    // this.setState({ loading: true });
    // this.getReleaseMetadata('22.0.0');
    this.getReleases()
    this.getReleaseMetadata(this.state.regressionVersion)

  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Container maxWidth="lg" className={classes.container}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Title>Regression Sign Off</Title>
              {this.state.loading && <BackdropProgress loading={this.state.loading} />}

              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">Regression Branch</InputLabel>
                <Select  value={this.state.regressionVersion} onChange={(e) => this.handleReleaseVersionChange(e)}>
                <MenuItem value="">
                  <em>Select Branch</em>
                </MenuItem>
                {this.state.releaseResponse.map((name, index) => (  
                     <MenuItem key={index} value={name}>{name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br></br>
              {this.state.loading ? (
                <Skeleton variant="rect" width="100%"></Skeleton>
              ) : (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {/* <TableCell></TableCell> */}
                        <TableCell>Team</TableCell>
                        <TableCell>Artifact</TableCell>
                        <TableCell>Version</TableCell>
                        <TableCell align="right">Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.promotionResponse.map((pr) => (

                        <TableRow hover key={pr.artifact}>
                          {/* <TableCell padding="checkbox">
                            <Checkbox inputProps={{ 'aria-label': 'select all desserts' }} />
                          </TableCell> */}
                          <TableCell>{pr.team}</TableCell>
                          <TableCell>{pr.artifact}</TableCell>
                          {/* <TableCell>{pr.versions[0].version}</TableCell> */}
                          <TableCell>{this.renderVersionsDropdown(pr.versions, pr.artifact)}</TableCell>
                          <TableCell align="right">{this.isQaApproved(pr.versions)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              <div align="right" className={classes.seeMore}>
                <Button variant="contained" color="primary" onClick={this.handleClickOpen}>
                  Sign Off
                </Button>
                <ConfirmDialog
                  title="Verify Sign Off"
                  open={this.state.confirmationDialog}
                  setOpen={this.setOpen}
                  onConfirm={this.updateReleaseArtifacts}
                  variant="confirm"
                >
                  <TableContainer >
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                      <TableCell>Artifact</TableCell>
                      <TableCell>Current Version</TableCell>
                      <TableCell>Promoted Version</TableCell>
                      <TableCell>SCM</TableCell>
                      </TableRow>
                      </TableHead>
                      
                      <TableBody>
                        {this.renderConfirmationDialog()}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </ConfirmDialog>
              </div>
            </Paper>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default withStyles(useStyles)(QaPromotion);
